module.exports = __webpack_public_path__ + "img/paraguay.881a74a5.svg";